import React, { useEffect, useState } from 'react';
import Header from '../components/Header';
import Hero from '../components/Hero';
import About from '../components/About';
import Experience from '../components/Experience';
import Education from '../components/Education';
import Projects from '../components/Projects';
import Skills from '../components/Skills';
import Languages from '../components/Languages';
import Contact from '../components/Contact';
import Footer from '../components/Footer';

const Portfolio = () => {
  const [isVisible, setIsVisible] = useState({});

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            setIsVisible((prev) => ({ ...prev, [entry.target.id]: true }));
          }
        });
      },
      { threshold: 0.1 }
    );

    const sections = document.querySelectorAll('[data-section]');
    sections.forEach((section) => observer.observe(section));

    return () => observer.disconnect();
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Header />
      <main>
        <Hero isVisible={isVisible.hero} />
        <About isVisible={isVisible.about} />
        <Experience isVisible={isVisible.experience} />
        <Education isVisible={isVisible.education} />
        <Projects isVisible={isVisible.projects} />
        <Skills isVisible={isVisible.skills} />
        <Languages isVisible={isVisible.languages} />
        <Contact isVisible={isVisible.contact} />
      </main>
      <Footer />
    </div>
  );
};

export default Portfolio;